/**
 * Separa o texto digitado no login em usuário e tenant (slug da empresa).
 * Formato: `<usuario>@<slug>`, separando pelo ÚLTIMO '@' (permite usuário e-mail:
 * `maria@empresa.com@slug`). Sem '@' ou sufixo que não seja slug válido, o texto
 * inteiro é tratado como usuário, sem tenant. Espaços nas pontas são removidos (trim).
 */
export interface UsuarioETenant {
  usuario: string;
  tenant?: string;
}

const SLUG_REGEX = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

function dividir(entrada: string): { usuario: string; slug: string } | null {
  const texto = entrada.trim();
  const idx = texto.lastIndexOf('@');
  if (idx <= 0) {
    return null;
  }
  const usuario = texto.slice(0, idx);
  const slug = texto.slice(idx + 1).toLowerCase();
  if (!usuario || !SLUG_REGEX.test(slug)) {
    return null;
  }
  return { usuario, slug };
}

export function separarUsuarioETenant(texto: string): UsuarioETenant {
  const original = (texto ?? '').trim();
  const partes = dividir(original);
  if (!partes) {
    return { usuario: original };
  }
  return { usuario: partes.usuario, tenant: partes.slug };
}

/** True quando o texto casa `<usuario>@<slug>` válido (usado quando loginExigeTenant=true). */
export function formatoLoginValido(texto: string): boolean {
  return dividir(texto ?? '') !== null;
}
